import { Stack, Typography, useTheme } from "@mui/material";
import { SelectField } from "components";
import { useFormContext } from "react-hook-form";
import { CreateOidcSso } from "./CreateOidcSso";
import { CreateSamlSso } from "./CreateSamlSso";
import { CopySsoRedirectUrl } from "../copy-sso-redirect";
import { useParams } from "react-router-dom";
import { useGetCustomerDetails } from "controller";

export const CreateSso = ({
  primaryButtonText,
  forWhom,
  ssoDetails,
  customerId,
}: {
  primaryButtonText: string;
  forWhom: "customers" | "resources";
  ssoDetails: any;
  customerId?: string;
}) => {
  const theme = useTheme();
  const { control, getValues, watch } = useFormContext();
  const watchType = watch("type");
  const watchSsoConnectorId = watch("ssoConnectorId");

  const containerStyles = {
    padding: "16px 24px",
    border: `1px solid ${theme.palette.neutral["010"]}`,
    borderRadius: "8px",
    bgcolor: theme.palette.neutral.main,
  };

  // const typeOptions =
  //   forWhom === "resources"
  //     ? [
  //         { label: "OIDC", value: "OIDC" },
  //         { label: "SAML", value: "SAML" },
  //       ]
  //     : [{ label: "OIDC", value: "OIDC" }];

  const typeOptions = [
    { label: "OIDC", value: "OIDC" },
    { label: "SAML", value: "SAML" },
  ];

  const isTypeFieldDisabled = () => {
    // if (forWhom !== "resources") return true;
    if (!watchSsoConnectorId) return false;
    if (watchType === "SAML" || watchType === "OIDC") {
      const originalSso = ssoDetails?.find(
        (sso: any) => sso.logto_connector_id === watchSsoConnectorId,
      );
      const hasApiMetadata =
        originalSso?.saml_metadata || originalSso?.saml_metadata_url;
      return !!hasApiMetadata;
    }
    return false;
  };

  const { id } = useParams();
  const { data: customerDetailsData, isLoading: isGetCustomerDetailsLoading } =
    useGetCustomerDetails({
      customerId: customerId || id,
    });
  return (
    <Stack
      sx={{
        p: "8px",
        gap: "12px",
        bgcolor: theme.palette.neutral["005"],
        minHeight: "100%",
      }}
    >
      <Stack
        sx={{
          gap: "16px",
          ...containerStyles,
        }}
      >
        <Typography variant="h6">Configure your IDP</Typography>
        <SelectField
          control={control}
          hideHelperBox
          name={"type"}
          value={"OIDC"}
          options={typeOptions}
          labelMappingKey="label"
          valueMappingKey="value"
          isClearable={false}
          disabled={isTypeFieldDisabled()}
        />
      </Stack>
      {watchType === "OIDC" ? (
        <CreateOidcSso customerDetailsData={customerDetailsData} />
      ) : watchType === "SAML" ? (
        <CreateSamlSso customerDetailsData={customerDetailsData} />
      ) : null}
      {primaryButtonText === "Update" && watchType === "OIDC" && (
        <CopySsoRedirectUrl
          logtoConnectorId={getValues("ssoConnectorId") || ""}
        />
      )}
    </Stack>
  );
};
